unit Reports.Shared;

interface
uses Generics.Collections;

type
  TReportUtils = class
    class function SQLToPascalCase(const Value: string; const AddSpaces: Boolean = False): string;
  end;

const
  ALL_DONATIONS = 'ALL_DONATIONS';
  GIFT_AID_DONATIONS = 'GIFT_AID_DONATIONS';
  NON_GIFT_AID_DONATIONS = 'NON_GIFT_AID_DONATIONS';
  CLAIM_ID = 'CLAIM_ID';
  DONATION_KIND = 'DONATION_KIND';
  SUBMISSION_DATE = 'SUBMISSION_DATE';
  BANKING_DATE = 'BANKING_DATE';
  SUMMARY_DATE_FIELDS: array of string = [BANKING_DATE, 'CLAIM_DATE', 'DATE_ADDED', 'LAST_UPDATED', 'TRANSACTION_DATE'];
  CLAIM_DATE_FIELDS: array of string = ['DATE_ADDED', 'FIRST_DONATION_DATE', 'LAST_DONATION_DATE', 'LAST_UPDATED', 'PAYMENT_RECEIVED_DATE', SUBMISSION_DATE];
  ONLY_CLAIMABLE_UNCLAIMED_DONATIONS = 'UNCLAIMED_1';
  ALL_UNCLAIMED_DONATIONS = 'UNCLAIMED_2';
  /// <summary>Unclaimed donations that fail the same checks as Only Claimable (validation issues export).</summary>
  UNCLAIMED_WITH_ISSUES_DONATIONS = 'UNCLAIMED_3';

var XDataToAureliusNames: TDictionary<string, string>;

implementation

uses SysUtils;

procedure LoadAndPopulateDictionary;
begin
  XDataToAureliusNames := TDictionary<string, string>.Create;
  with XDataToAureliusNames do
  begin
    Add('DN.CLAIM_STATUS', 'ClaimStatus');
    Add('ANALYSIS_CODE_1', 'AnalysisCode1');
    Add('ANALYSIS_CODE_2', 'AnalysisCode2');
    Add('ANALYSIS_CODE_3', 'AnalysisCode3');
    Add('BANKING_REFERENCE', 'BankingReference');
  end;
end;

{ TReportUtils }


class function TReportUtils.SQLToPascalCase(const Value: string; const AddSpaces: Boolean = False): string;
var
  lParts: TArray<string>;
  lPart: string;
  i: Integer;
begin
  if Value = '' then
    Exit('');

  Result := '';
  lParts := Value.Split(['_']);

  for i := 0 to High(lParts) do
  begin
    lPart := lParts[i];
    if lPart <> '' then
    begin
      // Capitalize first letter, lowercase the rest
      lPart := lPart.ToLower;
      if Length(lPart) > 0 then
        lPart[1] := UpCase(lPart[1]);

      if AddSpaces then
      begin
        if Result <> '' then
          Result := Result + ' ' + lPart
        else
          Result := lPart;
      end
      else
        Result := Result + lPart;
    end;
  end;
end;


initialization
  LoadAndPopulateDictionary;

{$IFDEF APP_SERVER}
finalization
  XDataToAureliusNames.Free;
{$ENDIF}

end.
